import { Card, Col, Form, Row, Tree } from 'antd';
import { ButtonBack, ButtonSubmit } from 'components/Common/Buttons';
import useTopbarTitleHooks from 'hooks/useTopbarTitleHooks';
import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { APP_ROUTE_PREFIX, RouteConstant } from 'routes/routesConstant';
import useOrgRepo from 'services/repo/useOrgRepo';
import useUserRepo from 'services/repo/useUserRepo';
import useRoleRepo from 'services/repo/useRoleRepo';
import { PRIVILEGE_ID } from 'utils/AccessPermissionConfig';
import Constant from 'utils/Constants';
import CustomAlert from 'utils/CustomAlert';
import EmptyData from 'components/Common/EmptyData';
import { setFieldValues } from 'utils/Helper';
import { dismissToast, errorToast, loadingToastId, successToast } from 'utils/Toast';
import {
  CustomFormItemText,
  CustomFormItemSelectDropdown,
  CustomFormItemEmail,
  CustomFormItemPassword,
  CustomFormItemSwitch
} from 'components/Common/CustomFormItem';

const init_field = {
  userFirstName: '',
  userLastName: '',
  userEmail: '',
  userPassword: '',
  orgId: null,
  status: '',
  listSelectedRoleId: []
};

export default function ManageUser() {
  const { userId } = useParams();
  useTopbarTitleHooks(`${userId ? 'Edit' : 'Create'} User`);
  const { isLoading: isLoadingSave, createUser, updateUser } = useUserRepo(false);
  const { isLoading: isLoadingGetById, getUserById } = useUserRepo(false);
  const { isLoading: isLoadingOrgList, getOrgList } = useOrgRepo(false);
  const { isLoading: isLoadingRole, hasUserRole } = useRoleRepo(false);

  const [dataField, setDataField] = useState(init_field);
  const [selectedRole, setSelectedRole] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [orgOptions, setOrgOptions] = useState([]);
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const fetchGetUserById = async (id) => {
    const response = await getUserById({ userId: id });
    if (response?.detail === 'OK' && response?.status === 200) {
      const data = response.data;
      form.setFieldsValue({
        userFirstName: data?.userFirstName,
        userLastName: data?.userLastName,
        userEmail: data?.userEmail,
        // userPassword: data?.userPassword,
        orgNameOption: data?.orgId,
        status: String(data?.status).toLowerCase() === 'true'
      });

      // ✅ Reset field userPassword agar tidak divalidasi di form instance
     form.resetFields(['userPassword']);

      setDataField({
        userFirstName: data?.userFirstName,
        userLastName: data?.userLastName,
        userEmail: data?.userEmail,
        // userPassword: data?.userPassword,
        orgId: data?.orgId,
        status: String(data?.status).toLowerCase() === 'true'
      });
    }
  };

  const fetchDataUserRole = async (userId) => {
    const response = await hasUserRole({ userId: userId || null });
    if (response?.detail === 'OK' && response?.status === 200) {
      const list = response.data.map((item) => ({
        title: item.roleName,
        key: item.roleId,
        hasUser: item.hasUser
      }));
      setRoleList(list);
      const selected = list.reduce((acc, item, index) => {
        if (String(item.hasUser).toLowerCase() === "true") {
          acc.push(item?.key);
        }
        return acc;
      }, []);
      setSelectedRole(selected);
      //   const selected = list.filter(item => item.hasUser).map(item => item.key);
      //   setSelectedRole(selected);
    }
  };

  const fetchDataOrg = async () => {
    const payload = {
      pageNumber: 1,
      pageSize: 0,
      orderBy: 'orgId',
      isAscending: true,
      filter: {
        orgId: null,
        orgName: '',
        status: 'true'
      }
    };
    const res = await getOrgList(payload);
    if (res?.detail === 'OK' && res?.status === 200) {
      setOrgOptions(res.data.content.map(item => ({ label: item.orgName, value: item.orgId })));
    }
  };

  const handleCheckRole = (checkedKeysValue) => {
    const newSelected = checkedKeysValue.checked || [];
    setSelectedRole(newSelected);
  };

  const validateList = () => {
    const isCreate = !userId;

    const isValid =
      dataField.userFirstName?.trim() &&
      dataField.userLastName?.trim() &&
      dataField.userEmail?.trim() &&
      (isCreate ? dataField.userPassword : true) && // hanya wajib saat create
      dataField.orgId &&
      selectedRole.length > 0;

    return isValid;
  };


  const doSubmit = async () => {
    const payloadData = {
      userId, // tambahkan userId di payload update
      userFirstName: dataField.userFirstName.trim(),
      userLastName: dataField.userLastName.trim(),
      userEmail: dataField.userEmail.trim(),
      userPassword: dataField.userPassword,
      orgId: dataField.orgId,
      status: String(dataField.status), // pastikan dikirim sebagai string 'true' / 'false'
      roleList: selectedRole.map(roleId => ({ roleId }))
    };

    loadingToastId(Constant.message.savingData, payloadData);
    const response = userId ? await updateUser(payloadData) : await createUser(payloadData);
    dismissToast(payloadData);

    if (response?.detail === 'OK' && response?.status === 200) {
      successToast(Constant.message.saveDataSuccess);
      navigate(APP_ROUTE_PREFIX + '/' + RouteConstant.userManagement.user.index, { replace: true });
    } else if (response?.status === 400 && response?.message?.includes('email')) {
      errorToast('Email already exists. Please use another email.');
    } else {
      errorToast(Constant.message.errorSave);
    }
  };


  const validateSubmit = () => {
    form.validateFields()
      .then(() => {
        if (validateList()) {
          debugger
          doSubmit();
        } else {
          errorToast(Constant.message.errorForm);
        }
      })
      .catch(() => errorToast(Constant.message.errorForm));
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    CustomAlert.confirm({
      title: 'Submit User!',
      description: 'Are you sure you want to submit this data?',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      type: 'primary',
      onConfirmButton: () => validateSubmit()
    });
  };

  useEffect(() => {
    fetchDataOrg();
    if (userId) {
      fetchGetUserById(userId);
      fetchDataUserRole(userId);
    } else {
      fetchDataUserRole(null);
    }
  }, []);

  return (
    <div>
      <Card>
        <Form
          form={form}
          layout="horizontal"
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
          labelAlign="left"

        >

          <Row gutter={[16]}>
            <Col span={24}>
              <CustomFormItemText
                nameFormItem="userFirstName"
                label="First Name"
                placeholder="Fill in Firstname"
                required
                value={dataField.userFirstName}
                onChange={(e) => setDataField(prev => ({ ...prev, userFirstName: e.target.value }))}
              />
            </Col>

            <Col span={24}>
              <CustomFormItemText
                nameFormItem="userLastName"
                label="Last Name"
                placeholder="Fill in Lastname"
                required
                value={dataField.userLastName}
                onChange={(e) => setDataField(prev => ({ ...prev, userLastName: e.target.value }))}
              />
            </Col>

            <Col span={24}>
              <CustomFormItemEmail
                nameFormItem="userEmail"
                label="Email"
                placeholder="Fill in Email"
                required
                value={dataField.userEmail}
                onChange={(e) => setDataField(prev => ({ ...prev, userEmail: e.target.value }))}
              />
            </Col>
            {!userId && (
              <Col span={24}>
                <CustomFormItemPassword
                  nameFormItem="userPassword"
                  label="Password"
                  placeholder="Fill in Password"
                  required={true} // ❗ hanya required jika create
                  value={dataField.userPassword}
                  onChange={(e) => setDataField(prev => ({ ...prev, userPassword: e.target.value }))}
                />
              </Col>
            )}

            <Col span={24}>
              <CustomFormItemSelectDropdown
                nameFormItem="orgNameOption"
                label="Organization"
                placeholder="Select Organization"
                required
                showSearch
                loading={isLoadingOrgList}
                options={orgOptions}
                value={dataField.orgId}
                onChange={(value) => setDataField(prev => ({ ...prev, orgId: value }))}
              />
            </Col>

            <Col span={24}>
              <CustomFormItemSwitch
                nameFormItem="status"
                label="Is Active"
                value={dataField.status}
                onChange={(checked) => setDataField(prev => ({ ...prev, status: checked }))}
              />
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <h3>Role</h3>
              {isLoadingRole ? (
                <p>Loading...</p>
              ) : roleList.length > 0 ? (
                <Tree
                  checkable
                  defaultExpandAll
                  checkStrictly
                  selectable={false}
                  treeData={roleList}
                  onCheck={handleCheckRole}
                  checkedKeys={selectedRole}
                />
              ) : (
                <EmptyData />
              )}
            </Col>
          </Row>

          <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
            <ButtonBack onClick={() => navigate(APP_ROUTE_PREFIX + '/' + RouteConstant.userManagement.user.index)} disabled={isLoadingGetById || isLoadingSave} />
            <ButtonSubmit onClick={handleFormSubmit} loading={isLoadingSave} disabled={isLoadingGetById || isLoadingSave} />
          </div>
        </Form>
      </Card>
    </div>
  );
}
